module.exports = __webpack_public_path__ + "static/media/ancestry_covid19_severity_plot.1bf3e15a.png";